import React from "react";

const Pill = ({ children }) => (
  <span className="pill-badge">{children}</span>
);

export default function Header() {
  return (
    <header id="about" className="bg-primary text-white text-center header1">
      <div className="px-5 container1 d-flex flex-column align-items-center py-4  header1">
        <img className="img-fluid mb-4 pt-0 profile-img" src="img/prof.png" alt="Alexander Aprelkin" />

        <h1  className="myname mt-0">Alexander Aprelkin</h1>
        <p className="skills hero-subtitle" style={{ marginTop: ".9rem", opacity: ".95", maxWidth: 980 }}>
          Stabilizing critical backend systems and payment integrations in production

        </p>
        <div className="cta-group" style={{ marginTop: "1rem" }}>
          <a href="#projects" className="btn-cta2 cta-blue">
            View projects
          </a>
          <a href="#contact" className="btn-cta2 cta-green">
            Schedule a call
          </a>
        </div>
        <br />
        <h2 className="skills hero-title" >
          Senior Backend Consultant • Payments • Real-Time Systems • Java/Kafka/Cloud
        </h2>



        <div className="hero-pills" style={{ marginTop: ".6rem", maxWidth: 980 }}>
          <Pill>Java/Kotlin (Spring Boot, Quarkus)</Pill>
          <Pill>Payment authorization flows</Pill>
          <Pill>Kafka/event-driven systems</Pill>
          <Pill>Cloud/Kubernetes/Docker</Pill>
          <Pill>Production stabilization (24/7)</Pill>
          <Pill>Python data pipelines</Pill>
          <Pill>Big data (Spark/Flink)</Pill>

        </div>



        <div className="hero-meta" style={{ marginTop: "1rem", opacity: ".95" }}>
          <div style={{ marginBottom: ".5rem" }}>
            Freelance contracts • Remote or hybrid
          </div>
          <div className="language-flags">
            <img src="/img/icons8-germany-48.png" alt="German" /> <span style={{ opacity: ".7" }}>|</span>{" "}
            <img src="/img/icons8-usa-48.png" alt="English" />
            <div className="subline" style={{ marginTop: ".35rem" }}>
              Available in German and English
            </div>
          </div>
        </div>




      </div>
    </header>
  );
}
